import { Button } from './component';


export default Button;
